class ThemeColorSelector extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const value = this.querySelector('.product-info__option-value');
    if (!value) return;

    const selected = value.textContent;
    const desktop = window.matchMedia('(min-width: 1000px)');
    let hovered = null;
    let focused = null;
    const getSwatch = (target) => {
      const swatch = target instanceof Element ? target.closest('a') : null;
      return swatch && this.contains(swatch) ? swatch : null;
    };
    const update = () => {
      const swatch = desktop.matches ? hovered || focused : null;
      value.textContent = swatch?.textContent.trim() || selected;
    };

    this.querySelector('a.is-selected')?.setAttribute('aria-current', 'page');
    for (const type of ['pointerover', 'pointerout', 'focusin', 'focusout']) {
      this.addEventListener(type, (event) => {
        const target = type === 'pointerout' || type === 'focusout'
          ? event.relatedTarget
          : event.target;
        if (type.startsWith('pointer')) hovered = getSwatch(target);
        else focused = getSwatch(target);
        update();
      }, options);
    }
    desktop.addEventListener('change', update, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('theme-color-selector')) {
  customElements.define('theme-color-selector', ThemeColorSelector);
}
